(function ($) {
  /**
   * Class Loadmore.
   */
  class PortfolioList {
    /**
     * Contructor.
     */
    constructor() {
      this.ajaxUrl = siteConfig?.ajaxUrl ?? "";
      this.ajaxNonce = siteConfig?.ajax_nonce ?? "";
      this.list = $(".portfolio-tags-list");
      this.container = $(".portfolio-posts");
      this.isLoading = false;

      this.init();
    }

    init() {
      if (!this.list.length) {
        return;
      }
      this.firstLoadPortfolioTags();

      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          term: "all",
          action: "load_posts_by_terms",
          ajax_nonce: this.ajaxNonce,
        },
        success: (response) => {
          this.container.append(response);
        },
        error: (response) => {
          console.log("ERROR: " + response);
        },
      });
    }

    handleLoadPostsByTag(e) {
      if (!this.isLoading) {
        this.isLoading = true;

        this.container.html("Loading...");

        this.items = document.querySelectorAll(".portfolio-tags-list>li");
        this.items.forEach((item) => {
          item.dataset.active = "";
        });

        if (e.target.dataset.active === "") {
          e.target.dataset.active = "active";
        }

        $.ajax({
          url: this.ajaxUrl,
          type: "post",
          data: {
            term: e.target.dataset.value,
            action: "load_posts_by_terms",
            ajax_nonce: this.ajaxNonce,
          },
          success: (response) => {
            this.container.html("");
            this.container.append(response);
            this.isLoading = false;
          },
          error: (response) => {
            console.log("ERROR: " + response);
            this.isLoading = false;
          },
        });
      }
    }

    firstLoadPortfolioTags() {
      $.ajax({
        url: this.ajaxUrl,
        type: "post",
        data: {
          action: "load_posts_by_tax",
          ajax_nonce: this.ajaxNonce,
        },
        success: (response) => {
          this.list.append(response);

          this.items = document.querySelectorAll(".portfolio-tags-list>li");
          this.items.forEach((item) => {
            item.addEventListener("click", (e) => this.handleLoadPostsByTag(e));
          });
        },
        error: (response) => {
          console.log("ERROR: " + response);
        },
      });
    }
  }

  new PortfolioList();
})(jQuery);

const faqList = document.querySelector(".faq-list");
const faqItems = faqList.querySelectorAll(".faq-item");

faqItems.forEach((faqItem) => {
  faqItem.addEventListener("click", (elem) => {
    const curItem = elem.currentTarget;
    const curPar = curItem.querySelector("p");

    if (curItem.getAttribute("data-state") === "") {
      curItem.setAttribute("data-state", "active");
      curPar.style.maxHeight = curPar.scrollHeight + 60 + "px";
      return;
    }

    curItem.setAttribute("data-state", "");
    curPar.style.maxHeight = null;
  });
});

const infotabs = document.querySelectorAll(".infotab");

function removeItemWithSlice(array, elem) {
  const firstArr = Array.from(array).slice(0, elem);
  const secondArr = Array.from(array).slice(elem + 1);
  return [...firstArr, ...secondArr];
}

infotabs.forEach((infotab) => {
  infotab.addEventListener("click", (elem) => {
    const curItem = elem.currentTarget;
    const numField = infotab.children[0];

    const curItemPos = Array.from(infotabs).indexOf(curItem);
    const leftItems = removeItemWithSlice(infotabs, curItemPos);

    if (window.screen.width > 991) {
      if (curItem.getAttribute("data-state") === "") {
        curItem.setAttribute("data-state", "active");
        numField.innerText = numField.getAttribute("data-value");
        return;
      }
      curItem.setAttribute("data-state", "");
      numField.innerText = "?";
    }

    if (window.screen.width <= 991) {
      leftItems.forEach((infotab) => {
        infotab.setAttribute("data-state", "");
        infotab.children[0].innerText = "?";
      });

      numField.innerText = numField.getAttribute("data-value");

      if (curItem.getAttribute("data-state") === "") {
        curItem.setAttribute("data-state", "active");
        return;
      }

      curItem.setAttribute("data-state", "");
      numField.innerText = "?";
    }
  });

  infotabs[0].setAttribute("data-state", "active");
  infotabs[0].children[0].innerText =
    infotabs[0].children[0].getAttribute("data-value");

  // if (window.screen.width <= 991 && !window.screen.width > 992) {
  //   infotab.addEventListener("click", (elem) => {
  //     const curItem = elem.currentTarget;
  //     const numField = infotab.children[0];

  //     const curItemPos = Array.from(infotabs).indexOf(curItem);
  //     const leftItems = removeItemWithSlice(infotabs, curItemPos);

  //     leftItems.forEach((infotab) => {
  //       infotab.setAttribute("data-state", "");
  //       infotab.children[0].innerText = "?";
  //     });

  //     numField.innerText = numField.getAttribute("data-value");

  //     if (curItem.getAttribute("data-state") === "") {
  //       curItem.setAttribute("data-state", "active");
  //       return;
  //     }

  //     curItem.setAttribute("data-state", "");
  //     numField.innerText = "?";
  //   });
  // }
  // if (window.screen.width > 992) {
  // }
});

const sliderItems = document.querySelectorAll(".services-slide");
const sliderFooterLinks = document?.querySelectorAll(
  "[data-footertype='services'] > ul > li"
);
let sliderItemCount = 0;

sliderItems.forEach((sliderItem) => {
  sliderItem.setAttribute("data-slide", sliderItemCount++);

  sliderItem.addEventListener("click", (elem) => {
    const curItem = elem.currentTarget;
    const curItemCount = curItem.getAttribute("data-slide");
    const curItemCard = document.querySelector(
      `.services-card[data-slide="` + curItemCount + `"]`
    );

    sliderItems.forEach((sliderItem) => {
      sliderItem.setAttribute("data-state", "");
    });

    sliderCards.forEach((sliderCard) => {
      sliderCard.setAttribute("data-state", "");
    });

    if (curItem.getAttribute("data-state") === "") {
      curItem.setAttribute("data-state", "active");
      curItemCard.setAttribute("data-state", "active");
      return;
    }

    curItem.setAttribute("data-state", "");
  });
});

const sliderCards = document.querySelectorAll(".services-card");
let sliderCardCount = 0;
sliderCards.forEach((sliderCard) => {
  sliderCard.setAttribute("data-slide", sliderCardCount++);
  sliderCard.setAttribute("data-state", "");

  const xMark = sliderCard.querySelector(".xmark");
  sliderCard.addEventListener("click", (e) => {
    if (e.target === xMark) {
      sliderCard.setAttribute("data-state", "");
      sliderItems.forEach((item) => {
        item.setAttribute("data-state", "");
      });
    }
  });
});

if (sliderFooterLinks.length !== 0) {
  let sliderFooterLinkCounter = 0;
  sliderFooterLinks.forEach((link) => {
    link.setAttribute("data-slide", sliderFooterLinkCounter++);

    link.addEventListener("click", (e) => sliderFooterLinkHandler(e));
  });
  function sliderFooterLinkHandler(e) {
    const currentLink = e.currentTarget;
    const currentLinkDataSlide = currentLink.dataset.slide;

    const curItemCard = document.querySelector(
      `.services-card[data-slide="` + currentLinkDataSlide + `"]`
    );
    const sliderItem = document.querySelector(
      `.services-slide[data-slide="` + currentLinkDataSlide + `"]`
    );

    if (curItemCard && sliderItem) {
      sliderCards.forEach((item) => {
        item.setAttribute("data-state", "");
      });
      sliderItems.forEach((item) => {
        item.setAttribute("data-state", "");
      });

      curItemCard.setAttribute("data-state", "active");
      sliderItem.setAttribute("data-state", "active");
    }
  }
}

// window.addEventListener("load", () => {
//   const pageSingle = document.querySelector(".page-single");
//   const slider = document.querySelector(".services-slider");
//   const pageSingleSize = pageSingle.offsetWidth;

//   slider.style.width = pageSingleSize + "px";
// });

// window.addEventListener("resize", () => {
//   const pageSingle = document.querySelector(".page-single");
//   const slider = document.querySelector(".services-slider");
//   const pageSingleSize = pageSingle.offsetWidth;

//   if (
//     document.querySelector("body").offsetWidth < 970 &&
//     document.querySelector("body").offsetWidth > 690
//   ) {
//     slider.style.width = document.querySelector("body").offsetWidth - 82 + "px";
//   }
//   if (document.querySelector("body").offsetWidth <= 690) {
//     slider.style.width =
//       document.querySelector(".wrapper").offsetWidth - 32 + "px";
//   }
// });

function getInTouchAnimation(button) {
  const text = button.innerText;
  const letterArray = Array.from(text);
  button.innerText = "";

  addWordToText(button, letterArray);
}

function addWordToText(button, letterArray) {
  if (letterArray.length === 0) return;

  setTimeout(() => {
    if (letterArray[0] === " ") {
      button.innerText += "\xa0";
    }
    button.innerText += letterArray[0];

    addWordToText(button, letterArray.slice(1));
  }, 200);
}

let isBtnAnimation = false;

const closeGetInTouch = () => {
  const getInTouchBtn = document.querySelector(".mobile-getintouch");
  const getInTouchBtnText = getInTouchBtn.querySelector(
    ".mobile-getintouch-text"
  );

  if (
    window.scrollY > 300 &&
    document.querySelector("body").offsetWidth < 691
  ) {
    getInTouchBtn.setAttribute("data-state", "active");
    if (!isBtnAnimation) {
      isBtnAnimation = true;
      getInTouchAnimation(getInTouchBtnText);
    }
  }
  if (window.scrollY < 300) {
    getInTouchBtn.setAttribute("data-state", "");
  }
};

// window.addEventListener("scroll", closeGetInTouch);

// const getInTouchBtn = document.querySelector(".mobile-getintouch");

// getInTouchBtn.addEventListener("touchstart", handleTouchStart, false);
// getInTouchBtn.addEventListener("touchmove", handleTouchMove, false);

// var xDown = null;
// var yDown = null;

// function handleTouchStart(evt) {
//   xDown = evt.touches[0].clientX;
//   yDown = evt.touches[0].clientY;
// }

// function handleTouchMove(evt) {
//   if (!xDown || !yDown) {
//     return;
//   }

//   var yUp = evt.touches[0].clientY;

//   var yDiff = yDown - yUp;

//   if (yDiff > 0) {
//     evt.currentTarget.setAttribute("data-state", "");
//     window.removeEventListener("scroll", closeGetInTouch);
//   }

//   yDown = null;
// }

document
  .querySelectorAll(".anchor-hash-header")
  .forEach((item) => item.addEventListener("click", (evt) => handleClick(evt)));

function handleClick(event) {
  event.preventDefault();
  const headerOffset = document.querySelector(".header").clientHeight; // полная высота header'a
  const contentAnchors = document.querySelectorAll(".anchor-hash-content");
  const href = event.target.getAttribute("href");
  const elementToScroll = Array.from(contentAnchors).filter(
    (item) => item.getAttribute("id") === href
  );
  const elementPosition = elementToScroll[0].offsetTop;
  window.scrollTo({
    top: elementPosition - headerOffset,
    behavior: "smooth",
  });
}
